import { IHttpClient } from '@/core/services/http'
import { AppSettingsResponse } from '../types/api-responses/app-settings'
import { AppSettingsModel } from '../types/models/app-settings.model'

export function createGetAppSettingsUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function () {
    try {
      const response = await httpClient
        .version('v1')
        .get<{ data: AppSettingsResponse }>('/website/customer/settings')

      return resolver(response.data.data)
    } catch (_) {
      return null
    }
  }
}

function resolver(settings: AppSettingsResponse): AppSettingsModel {
  return {
    relationWithPassenger: settings.relationWithPassenger,
    generalInfo: {
      email: settings.generalInfo.find(el => el.key === 'email')?.value || '',
      appStoreDownloadUrl:
        settings.generalInfo.find(el => el.key === 'app_store_download_url')
          ?.value || '',
      googlePlayDownloadUrl:
        settings.generalInfo.find(el => el.key === 'google_play_download_url')
          ?.value || '',
      companyLocation:
        settings.generalInfo.find(el => el.key === 'company_location')?.value ||
        '',
      driverAppStoreDownloadUrl:
        settings.generalInfo.find(
          el => el.key === 'driver_app_store_download_url',
        )?.value || '',
      driverGooglePlayDownloadUrl:
        settings.generalInfo.find(
          el => el.key === 'driver_google_play_download_url',
        )?.value || '',
      dispatcherWebAppUrl:
        settings.generalInfo.find(el => el.key === 'dispatcher_url')?.value ||
        '',
    },
  }
}
